<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-body tab2-card">
          <form [formGroup]="taskForm" class="needs-validation" novalidate>
            <div class="form-group row">
              <div class="col-xl-2 col-md-2">
                <label>Numar task</label>
              </div>
              <div class="col-xl-3 col-md-3">
                <input class="form-control" type="text" formControlName="taskNumber">
              </div>
              <div class="col-xl-2 col-md-2">
                <label>Denumire task</label>
              </div>
              <div class="col-xl-3 col-md-3">
                <input class="form-control" type="text" formControlName="taskName">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-2 col-md-2">
                <label>Numar contract furnizare</label>
              </div>
              <div class="col-xl-3 col-md-3">
                <input class="form-control" type="text" formControlName="supplierContractNumber">
              </div>
              <div class="col-xl-2 col-md-2">
                <label>Data contract furnizare</label>
              </div>
              <div class="col-xl-3 col-md-3">
                <input class="form-control" type="date" formControlName="supplierContractDate" onkeydown="return false">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-2 col-md-2">
                <label>Numar contract retea</label>
              </div>
              <div class="col-xl-3 col-md-3">
                <input class="form-control" type="text" formControlName="networkContractNumber">
              </div>
              <div class="col-xl-2 col-md-2">
                <label>Data contract retea</label>
              </div>
              <div class="col-xl-3 col-md-3">
                <input class="form-control" type="date" formControlName="networkContractDate" onkeydown="return false">
              </div>
            </div>
            <div *ngIf="false" class="form-group row">
              <div class="col-xl-2 col-md-2">
                <label>Numar conventie</label>
              </div>
              <div class="col-xl-3 col-md-3">
                <input class="form-control" type="text" formControlName="conventionNumber">
              </div>
              <div class="col-xl-2 col-md-2">
                <label>Data conventie</label>
              </div>
              <div class="col-xl-3 col-md-3">
                <input class="form-control" type="date" formControlName="conventionDate" onkeydown="return false">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-2 col-md-2">
                <label>Data intrare in efectivitate</label>
              </div>
              <div class="col-xl-3 col-md-3">
                <input class="form-control" type="date" formControlName="effectiveDate" onkeydown="return false">
              </div>
              <div class="col-xl-2 col-md-2">
                <label>Valabil pana la</label>
              </div>
              <div class="col-xl-3 col-md-3">
                <input class="form-control" type="date" formControlName="expirationDate" onkeydown="return false">
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Documente spre semnare</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-8 col-md-8">
                <span class="font-weight-bold">Fisier</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span class="font-weight-bold">Dimensiune</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span class="font-weight-bold">Optiuni</span>
              </div>
            </div>
            <div class="form-group row" *ngFor="let file of fileList">
              <div class="col-xl-8 col-md-8">
                <span>{{file.fileName}}</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span *ngIf="file.fileByteSize">{{file.fileByteSize | fileSize}}</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <a *ngIf="file.file || file.fileUrl" class="link pointer"
                  (click)="documentService.downloadDocument(file)">Descarca</a>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-auto col-md-auto">
                <h4>Decizie</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-auto col-md-auto">
                <label>Validati cererea de schimbare?</label>
              </div>
              <div class="col-xl-auto col-md-auto">
                <label class="d-block">
                  <input class="radio_animated" type="radio" (click)="setRequestValidated(true)"
                    [checked]="!!taskForm?.controls?.requestValidated?.value"
                    [disabled]="taskForm?.controls?.requestValidated?.disabled">
                  DA
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" (click)="setRequestValidated(false)"
                    [checked]="!taskForm?.controls?.requestValidated?.value"
                    [disabled]="taskForm?.controls?.requestValidated?.disabled">
                  NU
                </label>
              </div>
            </div>
            <div class="form-group row" *ngIf="!taskForm?.controls?.requestValidated?.value">
              <div class="col-xl-auto col-md-auto">
                <label>Motivul pentru care nu validati</label>
              </div>
              <div class="col-xl-5 col-md-5">
                <textarea style="width:100%" rows="4" formControlName="invalidationReason"></textarea>
              </div>
            </div>
            <ng-container *ngIf="!!taskForm?.controls?.requestValidated?.value">
              <div class="form-group row">
                <div class="col-xl-auto col-md-auto">
                  <h4>Semnatura</h4>
                </div>
              </div>
              <div class="signature-clear">
                <i class="fa fa-times-circle fa-2x red" (click)="signaturePad.clear()"></i>
              </div>
              <div #signatureDiv class="form-group row">
                <signature-pad #signaturePad class="signature" [options]="signaturePadOptions"></signature-pad>
              </div>
              <div class="form-group row">
                <label style="word-wrap:break-word">
                  <input class="checkbox_animated" id="signatureCheckBox" type="checkbox"
                    formControlName="signatureCheckBox" />
                  {{signatureCheckBoxText}}
                </label>
              </div>
              <br>
            </ng-container>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
